import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-forgot-password-confirmation',
  templateUrl: './forgot-password-confirmation.component.html',
  styleUrls: ['./forgot-password-confirmation.component.scss'],
})
export class ForgotPasswordConfirmationComponent implements OnInit {
  @Input() email: string = '';

  constructor(public readonly popoverCtrl: PopoverController) {}

  ngOnInit() {
    return;
  }
}
